<template>
    <v-card class="fill-height" :style="isThemeAja ? { backgroundColor: '#1E3945' } : {}">
        <CardTitle :text="title" />
        <v-card-text class="text-center">
            <!-- User Success Content -->
            <template v-if="userType === 'user'">
                <v-card color="transparent" class="elevation-0" style="z-index: 1;">
                    <v-card-text>
                        <div class="body-1">
                            <slot name="user-content">
                                <!-- Bravo Card User Content -->
                                <template v-if="cardType === 'bravo'">
                                    <p class="mb-0">Bienvenue dans le monde des COGITEUSES et COGITEURS…</p>
                                    <p class="mb-0">Vous allez commencer votre travail de reconnexion des neurones !</p>
                                    <p><b>En tout premier lieu, nous allons faire un peu connaissance, grâce à votre PROFIL</b></p>
                                    <p class="text-center"><b>Pourquoi remplir mon PROFIL ?</b></p>
                                    <p class="mb-0">
                                        Ces informations sont <b>importantes</b> pour nous aider à <b>porter votre cause</b> 
                                        auprès des politiques, des organismes d'assurance maladie, des agences régionales de soins, 
                                        des mutuelles et des prévoyances.
                                    </p>
                                    <p>
                                        Grâce à cela, nous avancerons ensemble et plus loin pour permettre la reconnaissance des 
                                        troubles onCOGITIFS et ainsi continuer à accompagner tous les futurs patients, 
                                        comme vous aujourd'hui.
                                    </p>
                                </template>
                                <!-- Default Thanks Card Content -->
                                <template v-else>
                                    <p>Vous faites partie de nos mécènes et bienfaiteurs onCOGITEURS !</p>
                                    <p>Grâce à vous, onCOGITE va poursuivre plus loin encore ses actions,</p>
                                    <p>Plein d'autres patients pourront, comme vous, reconnecter leurs neurones et reprendre le cours de leur vie.</p>
                                    <p>Merci de votre confiance.</p>
                                </template>
                            </slot>
                        </div>
                        <slot name="user-action">
                            <!-- Bravo Card User Action -->
                            <template v-if="cardType === 'bravo'">
                                <v-btn color="primary" :to="{name: 'ProfileSurvey'}">
                                    Accéder à mon profil
                                </v-btn>
                                <div class="body-1 mt-10 text-center">
                                    <p>
                                        Vous ne souhaitez pas remplir votre profil.<br />
                                        Ce n'est pas un problème, contactez SOPHIE PRADA au 06 68 91 53 15:<br />
                                        Elle vous accompagnera pour choisir votre atelier et faire votre première inscription.
                                    </p>
                                </div>
                            </template>
                        </slot>
                    </v-card-text>
                </v-card>
            </template>
            
            <!-- Pro Success Content -->
            <template v-else-if="userType === 'pro'">
                <v-card color="transparent" class="elevation-0" style="z-index: 1;">
                    <v-card-text>
                        <div class="body-1">
                            <slot name="pro-content">
                                <!-- Bravo Card Pro Content -->
                                <template v-if="cardType === 'bravo'">
                                    <p class="mb-8">Vous faites partie de l'équipe des Animateurs-Cogiteurs(euses).</p>
                                    <p class="mb-8">
                                        Prenez le temps de trouver vos marques sur la plateforme. 
                                        Notre équipe est là pour vous aider et vous accompagner.
                                    </p>
                                    <p class="mb-8">
                                        N'hésitez pas à contacter Sophie par mail 
                                        <a href="mailto:s.prada@oncogite.com">s.prada@oncogite.com</a>
                                        ou par tel <a href="tel:+33668915315">+33 6 68 91 53 15</a>
                                    </p>
                                    <p>
                                        Sophie est chargée de la création de votre espace atelier. 
                                        Après ce sera à vous de jouer:
                                    </p>
                                    <p class="mt-n4">- Créez et organisez les séances hebdomadaires de votre atelier</p>
                                    <p class="mt-n4">- Accédez aux supports numériques en lignes</p>
                                    <p class="mt-n4 mb-12">- Restez en contact avec les patients qui vous suivent.</p>
                                </template>
                                <!-- Default Pro Content -->
                                <template v-else>
                                    <p class="mb-8">Vous faites partie de l'équipe des Animateurs-Cogiteurs(euses).</p>
                                    <p class="mb-8">
                                        Prenez le temps de trouver vos marques sur la plateforme. 
                                        Notre équipe est là pour vous aider et vous accompagner.
                                    </p>
                                </template>
                            </slot>
                        </div>
                        <slot name="pro-action">
                            <!-- Bravo Card Pro Action -->
                            <template v-if="cardType === 'bravo'">
                                <v-btn color="primary" :to="{name: 'ProWorkshops'}">
                                    Aller dans mon espace Pro
                                </v-btn>
                            </template>
                        </slot>
                    </v-card-text>
                </v-card>
            </template>
            
            <!-- Default Content -->
            <template v-else>
                <slot></slot>
            </template>
        </v-card-text>
        <v-footer v-if="footerImage" style="z-index: 0" fixed color="transparent" class="pb-7">
            <v-img :src="require(`@/assets/images/${footerImage}`)" contain></v-img>
        </v-footer>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        title: {
            type: String,
            required: true
        },
        userType: {
            type: String,
            default: null,
            validator: value => ['user', 'pro', null].includes(value)
        },
        footerImage: {
            type: String,
            default: null
        },
        cardType: {
            type: String,
            default: 'default',
            validator: value => ['bravo', 'thanks', 'default'].includes(value)
        }
    },
    computed: {
        ...mapGetters(['isThemeAja'])
    }
}
</script> 